export const LOADER_FORMULARIO_COMPETENCIA          =       'LOADER_FORMULARIO_COMPETENCIA';
export const GET_FORMULARIO_COMPETENCIA             =       'GET_FORMULARIO_COMPETENCIA';
export const FORMULARIO_COMPETENCIA_FALLA           =       'FORMULARIO_COMPETENCIA_FALLA';
export const SAVE_LOADER_FORMULARIO_COMPETENCIA     =       'SAVE_LOADER_FORMULARIO_COMPETENCIA';
export const FORM_FORMULARIO_COMPETENCIA_FAIL       =       'FORM_FORMULARIO_COMPETENCIA_FAIL';

